/**
 * Connectors - Data source connectors (mirrors backend structure).
 * Each connector lives in its own folder: connectors/googleDrive/, etc.
 */

import { apiService } from '../services/api';

export interface ConnectorMeta {
  id: string;
  name: string;
  description: string;
  auth_type: string;
}

export async function getConnectors(): Promise<ConnectorMeta[]> {
  const res = await apiService.getDataSourceConnectors();
  return res.connectors || [];
}
